/**
 * 路由配置
 */
import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '@/store';
import setting from '@/config/setting';
import EleLayout from '@/layout';
import { menuToRoutes } from 'ele-admin';
import NProgress from 'nprogress';
import axios from '@/utils/request';
import { Message } from 'element-ui';

Vue.use(VueRouter);

// 静态路由
const routes = [
  {
    path: '/login',
    component: () => import('@/views/login/login'),
    meta: { title: '' }
  },
  {
    path: '*',
    component: () => import('@/views/exception/404')
  }
];

const router = new VueRouter({
  routes,
  mode: 'history'
});

// 路由守卫
router.beforeEach(async (to, from, next) => {
  NProgress.start();
  updateTitle(to);

  // 先验证 IP 白名单
  try {
    const res = await axios.get('/login/getip');
    const data = res.data;

    // 若后端返回非法访问，则直接拦截
    if (data.code === 0) {
      Message.error(data.msg || '非法访问');
      NProgress.done();
      return next(false); // 阻止路由跳转
    }
  } catch (e) {
    console.error('IP 验证异常:', e);
    Message.warning('无法验证 IP，继续访问');
  }

  if (setting.takeToken()) {
    if (!store.state.user.menus) {
      store
        .dispatch('user/getMenus')
        .then(({ menus, home }) => {
          router.addRoute({
            path: '/',
            component: EleLayout,
            redirect: setting.homePath || home,
            children: menuToRoutes(menus, (component) => import('@/views' + component))
          });
          next({ ...to, replace: true });
        })
        .catch(() => {
          next();
        });
    } else {
      next();
    }
  } else if (setting.whiteList.includes(to.path)) {
    next();
  } else {
    next({ path: '/login', query: to.path === '/' ? {} : { from: to.path } });
  }
});

router.afterEach(() => {
  setTimeout(() => {
    NProgress.done(true);
  }, 300);
});

export default router;

/**
 * 更新浏览器标题
 */
function updateTitle(route) {
  if (!route.path.startsWith('/redirect/')) {
    const names = [];
    if (route && route.meta && route.meta.title) {
      names.push(route.meta.title);
    }
    const appName = process.env.VUE_APP_NAME;
    if (appName) {
      names.push(appName);
    }
    document.title = names.join(' - ');
  }
}
